import React, { useMemo } from "react";
import { ICommentParent } from "../../../store/types";
import { Parent } from "../Parent/Parent";
import { FindTargetRefType } from "../Section/Section";

import "./Group.styles.scss";

interface IGroup {
  title?: string;
  comments: ICommentParent[];
  findTargetRef: FindTargetRefType;
}

export const Group: React.FC<IGroup> = ({ title, comments, findTargetRef }) => {
  const commentsList = useMemo(() => {
    return comments.map((comment: ICommentParent) => (
      <Parent
        findTargetRef={findTargetRef}
        comment={comment}
        key={comment.id}
      />
    ));
  }, [comments, findTargetRef]);

  return (
    <div className="group">
      <div className="group__head flex-row-fs-fc">
        {title ? title : "General Comments"}
      </div>
      {commentsList}
    </div>
  );
};
